export class Country {
  regionCode: string;
  countryCode: number;
  countryName: string;

  constructor(data = {}) {
    Object.keys(data).forEach((key) => (this[key] = data[key]));
  }
}
